// 空状态生成器：活动卡（activity）
export function createEmptyActivityPayload() {
  return {
    card_type: 'activity',
    type: 'activity',
    title: '请输入活动名称',
    imageUrl: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=1200&h=600&fit=crop&auto=format',
    address: '请填写活动地址',
    description: '这里请填写活动的描述',
    metaPairs: [],
    tags: [],
    card: {},
  };
}
